const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function getAuthHeaders() {
  const token = localStorage.getItem('session_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function saveSession(userData) {
  if (userData.session_token) {
    localStorage.setItem('session_token', userData.session_token);
  }
  localStorage.setItem('user', JSON.stringify(userData));
}

export function clearSession() {
  localStorage.removeItem('session_token');
  localStorage.removeItem('user');
}

export async function logout(navigate) {
  try {
    await fetch(`${BACKEND_URL}/api/auth/logout`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });
  } catch (_) {
    // best-effort — clear session regardless
  }
  clearSession();
  navigate('/login');
}
